import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    claimButton: (theme) => ({
        ':hover': {
            color: `${theme.colors.teal} !important`
        },

        color: theme.colors.plantation
    }),

    modalWrapper: {
        display: 'flex',
        flexDirection: 'column',
        px: 5,
        py: 3
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
